import { Api } from "./api"
import { GetTranslationProvidersResult } from "./api.types"
import { getGeneralApiProblem } from "./api-problem"

export class TranslationProviderApi {
  private api: Api

  constructor(api: Api) {
    this.api = api
  }
  
  async getAll() : Promise<GetTranslationProvidersResult> {
    try {
      const response = await this.api.getTranslationProviders()

      if (!response.ok) {
        const problem = getGeneralApiProblem(response)
        if (problem) return problem
      }

      const payload = response.data

      return { kind: 'ok', payload }
    } catch (e) {
      return { kind: "bad-data" }
    }
  }
}
